import React from "react";
import { useSiteSettings } from "@/components/SiteSettings";

const DEFAULT_LOGO_URL = "https://customer-assets.emergentagent.com/job_custom-catalog-6/artifacts/xzqwlruk_xyzplus%20logo.png";

export default function Logo({ size = 36, className = "", invert = false, withWordmark = false }) {
  const s = useSiteSettings();
  const url = s?.brand_header_logo || DEFAULT_LOGO_URL;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img loading="lazy" decoding="async"
        src={url}
        alt="XYZPLUS"
        style={{ height: size, width: size, borderRadius: size * 0.18, filter: invert ? "invert(1) brightness(2)" : undefined }}
        className="select-none object-contain transition-transform hover:scale-105"
        draggable={false}
      />
      {withWordmark && (
        <span className={`font-display font-black tracking-tighter ${invert ? "text-white" : "text-[#111111]"}`} style={{ fontSize: size * 0.55 }}>
          XYZ<span className="text-[#FF5722]">PLUS</span>
        </span>
      )}
    </span>
  );
}

// New brand badge — same orange-on-black XYZPLUS logo for footer/admin sidebar
export const FOOTER_LOGO_URL = DEFAULT_LOGO_URL;

export function BrandBadge({ size = 64, className = "" }) {
  const s = useSiteSettings();
  const url = s?.brand_footer_logo || s?.brand_header_logo || DEFAULT_LOGO_URL;
  return (
    <img loading="lazy" decoding="async"
      src={url}
      alt="XYZPLUS"
      style={{ height: size, width: size, borderRadius: size * 0.18 }}
      className={`select-none object-contain transition-transform hover:scale-105 ${className}`}
      draggable={false}
      data-testid="brand-badge"
    />
  );
}
